import React, { useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SharedButton from '../../components/Shared/SharedButton';
import TextInput from '../../components/Shared/TextInput';
import PageHeader from '../../components/Shared/PageHeader';
import { FaCheckDouble } from 'react-icons/fa6';
import CustomSearchDropdown from '../../components/Shared/CustomSearchDropdown';
import { createNewPayroll, getPayrunList } from '../../store/slices/PayslipSlice';
import { getCashBankAccounts } from '../../store/slices/AcountsSlice';
import i18next from 'i18next';

export const getCurrentMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

export default function CreatePayroll() {
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const lang = i18next.language;
  const { cashBankAccounts } = useSelector(state => state.acount);
  const { isLoading } = useSelector(state => state.payslip);

  const initialValues = {
    pay_period: getCurrentMonth(),
    account_code: ''
  };

  const validationSchema = Yup.object({
    pay_period: Yup.string().required(t('required')),
    account_code: Yup.string().required(t('required'))
  });

  useEffect(() => {
    dispatch(getCashBankAccounts());
  }, [dispatch]);

  const listAccountsvalues = cashBankAccounts?.data
    ? Object.entries(cashBankAccounts.data).map(([id, account]) => ({
        id: Number(account?.code),
        name: lang === 'ar' ? account.name_ar : account.name_en
      }))
    : [];



  const onSubmit = async (data, { resetForm }) => {
    try {
      const resultAction = await dispatch(createNewPayroll(data));
      if (createNewPayroll.fulfilled.match(resultAction)) {
        resetForm();
        navigate(-1);
      }
    } catch (error) {
      console.error('Error creating payroll:', error);
    }
  };

  return (
    <div className="flex flex-col w-full gap-4 max-h-[calc(100vh-150px)]">
      <PageHeader
        title={t('Create Payroll')}
        showBack
        onBack={() => navigate(-1)}
      />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit} className="space-y-4">
            <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 w-full'>
              <TextInput
                type={'month'}
                label={t('pay_period')}
                name={'pay_period'}
                placeholder='Enter pay_period'
                className='!p-1.5'
              />

              <CustomSearchDropdown
                label={`${t('cashBank')} ${t('account')}`}
                className='!w-full !border-gray-300 !bg-gray-100 !h-[30px]'
                name={'account_code'}
                options={listAccountsvalues}
                placeholder={`${t('select')} ${t('account')}`}
                value={formik.values.account_code}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>

            <div className='flex justify-end gap-2'>
              <SharedButton
                type='button'
                icon='pi pi-times'
                label={t('Cancel')}
                buttonType='reset'
                className='cancel-btn'
                onClick={() => {
                  navigate(-1);
                }}
              />
              <SharedButton 
                type='submit' 
                icon={<FaCheckDouble size={12} className='me-2' />}
                loading={isLoading}
                disabled={isLoading}
                label={t('Submit')} 
                className='submit-btn' 
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}